import { render, staticRenderFns } from "./RecetaList.vue?vue&type=template&id=c38700bc"
import script from "./RecetaList.vue?vue&type=script&lang=js"
export * from "./RecetaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports